import React, { StrictMode } from 'react';
import { render } from 'react-dom';
import Error404 from './components/Error404';
import '@shared_modules/local-propulsion';
import './styles.scss';

render(<Error404 />, document.getElementById('error-404'));

